import {
  NUMERICAL_GRADE_BANDS,
  GRADEANDLEXILELEVELS,
} from "@/constants/GradeAndLexileLevels";

/**
 * Gets values used for the display of each level.
 *
 * @param {{ grade_band: string }} level
 * @returns {{ formattedGrade: string, lexileRange: string }}
 */
const getLevelDisplayValues = (level) => {
  if (!level) return {};

  const numericGrade = NUMERICAL_GRADE_BANDS[level.grade_band];
  const { formattedGrade, lexileRange } = GRADEANDLEXILELEVELS[numericGrade];

  return { formattedGrade, lexileRange };
};

export default getLevelDisplayValues;
